(function () {
  'use strict';

  // --- Burger -------------------------------------------------------------------
  const initBurger = () => {
    const burger = document.getElementById('mainmenu-mobile');
    const nav    = document.getElementById('lns-nav');
    if (!burger || !nav) return;

    const setBackgroundInert = (isInert) => {
      Array.from(document.body.children).forEach((child) => {
        if (child === nav || child.contains(nav) || child === burger || child.contains(burger)) {
          return;
        }
        isInert ? child.setAttribute('inert', '') : child.removeAttribute('inert');
      });
    };

    const open = () => {
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mainmenu-isopen');
      setBackgroundInert(true);
      nav.querySelector('a, button')?.focus();
    };

    const close = () => {
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mainmenu-isopen');
      setBackgroundInert(false);
      closeAllSubmenus();
      burger.focus();
    };

    burger.addEventListener('click', () => {
      burger.getAttribute('aria-expanded') === 'true' ? close() : open();
    });

    // Close button handler - focus burger after close
    const closeBtn = document.querySelector('.mobile-menu-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent toggle.js from interfering
        if (burger.getAttribute('aria-expanded') === 'true') {
          close();
        }
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
        close();
        burger.focus();
      }
    });
  };

  // --- Submenu open/close -------------------------------------------------------
  /**
   * Findet das zugehörige Submenü-Panel zu einem Toggle-Button.
   * Sucht zunächst per aria-controls, dann am nächsten <ul>-Geschwister.
   */
  const getPanelFor = (btn) => {
    const id = btn.getAttribute('aria-controls');
    return (id && document.getElementById(id)) || btn.nextElementSibling;
  };

  const openSubmenu = (btn) => {
    const li    = btn.closest('li');
    const panel = getPanelFor(btn);
    if (!li || !panel) return;

    btn.setAttribute('aria-expanded', 'true');
    li.classList.add('submenuopen');
    panel.setAttribute('aria-hidden', 'false');
    // tabindex="-1" entfernen, damit Submenü-Links per Tab erreichbar sind
    panel.querySelectorAll('a[tabindex="-1"]').forEach(a => a.removeAttribute('tabindex'));
  };

  const closeSubmenu = (btn) => {
    const li    = btn.closest('li');
    const panel = getPanelFor(btn);
    if (!li || !panel) return;

    btn.setAttribute('aria-expanded', 'false');
    li.classList.remove('submenuopen');
    panel.setAttribute('aria-hidden', 'true');
    // tabindex="-1" wiederherstellen, damit Links im geschlossenen Submenü übersprungen werden
    panel.querySelectorAll('a').forEach(a => a.setAttribute('tabindex', '-1'));
  };

  const closeAllSubmenus = () => {
    document.querySelectorAll('nav.main-menu .menu-sub[aria-expanded="true"]')
      .forEach(closeSubmenu);
  };

  // --- Submenu-Buttons binden ---------------------------------------------------
  const bindSubmenuButtons = () => {
    document.querySelectorAll('nav.main-menu .menu-sub').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      getPanelFor(btn)?.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-label',
        'Untermenü: ' + btn.closest('li')?.querySelector(':scope > a')?.textContent?.trim()
      );

      btn.addEventListener('click', () => {
        btn.getAttribute('aria-expanded') === 'true'
          ? closeSubmenu(btn)
          : openSubmenu(btn);
      });
    });
  };

  // --- Desktop keyboard navigation (generisch) ----------------------------------
  /**
   * Gibt alle fokussierbaren Links innerhalb eines Elements zurück,
   * in DOM-Reihenfolge – unabhängig von Klassen oder Verschachtelungstiefe.
   */
  const getLinksIn = (el) => [...el.querySelectorAll('a')];

  const initDesktopKeyboard = () => {
    const nav      = document.querySelector('nav.main-menu');
    if (!nav) return;
    const topItems = [...nav.querySelectorAll(':scope > ul > li')];

    topItems.forEach((li, index) => {
      const topLink = li.querySelector(':scope > a');
      // Toggle-Button (beliebiges Element mit Klasse menu-sub oder role=button)
      const subBtn  = li.querySelector(':scope > .menu-sub');
      // Submenü = erstes direktes Kind-<ul>
      const submenu = li.querySelector(':scope > ul');

      // --- Tastatur auf dem Toplevel-Link --------------------------------------
      if (topLink) {
        topLink.addEventListener('keydown', (e) => {
          switch (e.key) {
            case 'ArrowRight':
              topItems[(index + 1) % topItems.length]
                ?.querySelector(':scope > a')?.focus();
              e.preventDefault(); break;

            case 'ArrowLeft':
              topItems[index - 1]
                ?.querySelector(':scope > a')?.focus();
              e.preventDefault(); break;

            case 'ArrowDown':
              if (subBtn && submenu) {
                openSubmenu(subBtn);
                getLinksIn(submenu)[0]?.focus();
              }
              e.preventDefault(); break;

            case 'Escape':
              if (subBtn) closeSubmenu(subBtn);
              e.preventDefault(); break;
          }
        });
      }

      // --- Tastatur innerhalb des Submenüs (generisch, alle Ebenen) -------------
      if (submenu && subBtn) {
        submenu.addEventListener('keydown', (e) => {
          const links = getLinksIn(submenu);
          const pos   = links.indexOf(document.activeElement);

          switch (e.key) {
            case 'ArrowDown':
              links[pos + 1]?.focus();
              e.preventDefault(); break;

            case 'ArrowUp':
              if (pos <= 0) topLink?.focus();
              else links[pos - 1]?.focus();
              e.preventDefault(); break;

            case 'Escape':
              closeSubmenu(subBtn);
              topLink?.focus();
              e.preventDefault(); break;
          }
        });

        // Submenü schließen, wenn Fokus das li vollständig verlässt
        li.addEventListener('focusout', (e) => {
          if (!li.contains(e.relatedTarget)) closeSubmenu(subBtn);
        });
      }
    });
  };

  // --- Init --------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', () => {
    initBurger();
    bindSubmenuButtons();
    initDesktopKeyboard();
  });

})();
